<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitCreateUnit">

      <div class="form-group">
        <p>Мат.единица: {{ unitData.name }} id={{ unitData.id }}</p>
      </div>

      <div class="form-group">
        <label for="with_nds">Дата оприходования:</label>
        <input
            id="with_nds"
            v-model="incomingDate"
            type="date"
            class="form-control form-control-sm"
        />
      </div>

    </form>
  </div>

</template>

<script>

import axios from "axios";

export default {
  // mixins: [validationMixin],
  name: "IncomingExistedCreateUnit",
  data() {
    return {
      incomingDate: null,
      unitData: {
        model_id: null,
        serial_number: null,
        incoming_date: null,
        name: null,
        description: null
      },
      submitted: false,
    }
  },
  validations: {
  },
  methods: {
    initData(currentTypeName, currentModel) {
      this.currentType = currentTypeName;
      this.currentModel = currentModel;
    },
    submitCreateUnit() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.packageData.$touch();
      if (!this.$v.packageData.$invalid) {
        this.$emit('submitCreateUnit', this.packageData);
      }
    },
    createNewUnit() {
      let formData = new FormData();
      formData.append('id', this.unitData.id);
      formData.append('incoming_date', this.unitData.incoming_date);
      formData.append('description', this.unitData.description);

      axios
          .post(`/v1/units/incoming`, formData)
          .then(resp => {
            this.$emit('new-unit-created', resp.data);
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    /**
     * Оприходование существующей мат единицы (такие попадаются, например, при использовании нештатного метода добавления в БД)
     */
    geoIncomingExistedUnit() {
      let formData = new FormData();
      formData.append('id', this.unitData.id);
      formData.append('incoming_date', this.incomingDate);
      axios
          .post(`/v1/units/geo-incoming-existed`, formData)
          .then(async resp => {
            this.$emit('existed-unit-geo-incomed', resp.data);
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    }
  },

  created() {

  }
};
</script>

<style scoped lang="css">

</style>
